import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

class PriceComponent extends Component {
  init() {
    this.focusableElement = this.element.querySelector('.price__text')

    if (!this.focusableElement) {
      return
    }

    document.addEventListener('keyup', event => this.onKeyUpHandler(event))
  }

  onKeyUpHandler(event) {
    if (!this.focusableElement || document.activeElement !== this.focusableElement) {
      return
    }

    if (event.key === 'Escape') {
      this.focusableElement.blur()
    }
  }
}

window.addEventListener('init-load', () => loadComponent(document.documentElement, 'price', PriceComponent))
